import { ref } from 'vue';
import { defineStore } from 'pinia';

type PreferenceValue = true | false | undefined;

export const usePreferencesStore = defineStore(
  'preferences',
  () => {
    const preferences = ref<Record<string, PreferenceValue>>({});

    function getPreference(key: string, defaultValue: boolean = false): boolean {
      const value = preferences.value[key];

      if (value === undefined) {
        preferences.value[key] = defaultValue;
        return defaultValue;
      }

      return value;
    }

    function setPreference(key: string, value: boolean) {
      preferences.value[key] = value;
    }

    return {
      preferences,
      getPreference,
      setPreference,
    };
  },
  {
    persist: true,
  },
);
